export type SpacingArgument = number | string;

export interface Spacing {
  (): number;
  (value: number): number;
  (topBottom: SpacingArgument, rightLeft: SpacingArgument): string;
  (
    top: SpacingArgument,
    rightLeft: SpacingArgument,
    bottom: SpacingArgument
  ): string;
  (
    top: SpacingArgument,
    right: SpacingArgument,
    bottom: SpacingArgument,
    left: SpacingArgument
  ): string;
}

export type SpacingOptions =
  | number
  | ((factor: number) => string | number)
  | number[];

function createUnarySpacing(spacing = 8) {
  if (typeof spacing === 'number') {
    return (abs: number) => {
      return spacing * abs;
    };
  }

  if (Array.isArray(spacing)) {
    return (abs: number) => {
      return spacing[abs];
    };
  }

  if (typeof spacing === 'function') {
    return spacing;
  }

  return () => undefined;
}

export default function createSpacing(themeSpacing = 8): Spacing {
  const transform = createUnarySpacing(themeSpacing);
  const spacing = (...args: any) => {
    if (args.length === 0) {
      return transform(1);
    }

    if (args.length === 1) {
      return transform(args[0]);
    }

    return args
      .map((argument: any) => {
        if (typeof argument === 'string') {
          return argument;
        }
        const output = transform(argument);
        return typeof output === 'number' ? `${output}px` : output;
      })
      .join(' ');
  };

  return spacing;
}
